import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, Stack, Typography, IconButton } from '@mui/material';

interface CreateNewDashboardDialogTitleProps {
  onClose: () => void;
}

export const CreateNewDashboardDialogTitle = ({
  onClose,
}: CreateNewDashboardDialogTitleProps) => {
  return (
    <DialogTitle>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6">Create Dashboard</Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
  );
};
